var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"async-loading",style:({ 'background-color': _vm.bgColor ? _vm.bgColor : false })},[_c('b-img-lazy',{attrs:{"src":require("@/assets/img/loader.gif"),"width":"300px","height":"200px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }